import { Component, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GuideModalService } from '../guide/guide-modal.service';
import { isTopLevelDomainFI } from '../shared/util/deploy-helper';
import { UserService } from '../user/user.service';
import { SideMenuLink } from './menus/side-menu/side-menu.component';
import { buildSideMenuLinks } from './side-menu-links';

@Component({
  selector: 'app-layout',
  styleUrls: ['./app-layout.component.scss'],
  template: `
    @if (!isSigningPage()) {
      <ipo-portal-layout class="layout">
        <ng-template ipoTopMenuContent>
          <div class="align-logo-text">
            @if (!isMobileScreen) {
              <img
                src="../assets/dp-logo-inline.svg"
                class="dp-logo"
                (click)="navigateToHome()"
              />

              <div class="vertical-divider"></div>
            } @else {
              <img
                src="../assets/dp-logo-icon.svg"
                class="dp-logo"
                (click)="navigateToHome()"
              />
            }
            <ipo-text class="country-text-style">
              {{
                isMobileScreen
                  ? deliveryPortalTextMobile
                  : (deliveryPortalTextDesktop | translate)
              }}
            </ipo-text>
          </div>

          <app-top-menu />
        </ng-template>

        @if (!missingRolesPage) {
          <ng-template ipoSideMenuContent>
            <div class="sidebar-content">
              <app-side-menu [links]="(sideMenuLinks$ | async)!" />

              <div>
                @if (isMobileScreen) {
                  <app-project-folder-opener class="folder-opener" />
                }

                <div class="company-logos">
                  <img src="../assets/global-connect-logo.svg" />
                </div>
              </div>
            </div>
          </ng-template>
        }

        <router-outlet [class.showBackgroundOverlay]="displayCookieBanner" />
        @if (showGuideModal$ | async) {
          <app-guide-modal (dismissed)="closeGuideModal()" />
        }
        @if (displayCookieBanner) {
          <app-cookie-banner />
        }
      </ipo-portal-layout>
    } @else {
      <router-outlet [class.showBackgroundOverlay]="displayCookieBanner" />
    }
  `,
  standalone: false,
})
export class AppLayoutComponent implements OnInit {
  sideMenuLinks$: Observable<SideMenuLink[]> | undefined;
  showGuideModal$: Observable<boolean> | undefined;

  isDeliveryPortalFi = isTopLevelDomainFI();
  isSigningPage = signal<boolean>(false);

  constructor(
    private userService: UserService,
    private guideModalService: GuideModalService,
    private router: Router,
  ) {}

  get missingRolesPage() {
    return this.router.url === '/missing-roles';
  }

  ngOnInit() {
    this.setIsSigningPage();
    this.sideMenuLinks$ = this.userService
      .getPortalUser$()
      .pipe(map(() => buildSideMenuLinks(this.userService)));
    this.showGuideModal$ = this.guideModalService.getModalStatus$();
  }

  setIsSigningPage() {
    this.isSigningPage.set(this.router.url.endsWith('/sign'));
  }

  closeGuideModal() {
    this.guideModalService.closeModal();
  }

  navigateToHome() {
    this.router.navigate(['/home']);
  }

  get displayCookieBanner() {
    return localStorage.getItem('cookieBannerClosed') !== 'true';
  }

  get isMobileScreen() {
    return window.matchMedia(`(max-width: 768px)`).matches;
  }

  get deliveryPortalTextMobile() {
    return this.isDeliveryPortalFi ? 'FI' : 'SE';
  }

  get deliveryPortalTextDesktop() {
    return this.isDeliveryPortalFi ? 'finland' : 'sweden';
  }
}
